import {CALENDAR_YEAR, T_MONTHS} from './graphConfig';

import {formatCurrency} from '../../utils/util';

import React from 'react';
import {useTranslation} from 'react-i18next';

const FuturePaymentOverview = (props) => {
  const {t} = useTranslation();
  const graphControllerClick = (chartMode) => {
    props.onControllerClick(chartMode);
  };
  return (
    <div className={'futurePaymentOverview'}>
      <div className={'installmentOverview'}>
        <div className={'installmentOverviewCard'}>
          <div className={'ioCardTitle'}>{t('TOTAL_AMOUNT')}</div>
          <div className={'ioCardValue'}>
            {formatCurrency(props.scheduleInfo?.totalAmount)}
          </div>
        </div>
        <div className={'installmentOverviewCard'}>
          <div className={'ioCardTitle'}>{t('INSTALLMENT_COUNTS')}</div>
          <div className={'ioCardValue'}>
            {props.scheduleInfo?.installmentCount}
          </div>
        </div>
      </div>
      <div className="graphViewController">
        <div
          className={`graphController ${
            props.chartMode === CALENDAR_YEAR && 'btnActive'
          }`}
          id="calendar_option"
          onClick={() => graphControllerClick(CALENDAR_YEAR)}
        >
          {t('CALENDAR_YEAR')}
        </div>
        <div
          className={`graphController ${
            props.chartMode === T_MONTHS && 'btnActive'
          }`}
          id="t_months_option"
          onClick={() => graphControllerClick(T_MONTHS)}
        >
          {t('12_MONTHS')}
        </div>
      </div>
    </div>
  );
};

export default FuturePaymentOverview;
